module.exports = __webpack_public_path__ + "web/img/img4.1d9f8a50.png";